import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type UserService from 'walden-fast/services/user';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppUserProfileModel = Resolved<
  ReturnType<AppUserProfileRoute['model']>
>;

export default class AppUserProfileRoute extends Route {
  @service('user') declare userService: UserService;

  async model() {
    return { user: await this.userService.getUser() };
  }
}
